import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ItemDetail from "@/pages/ItemDetail";
import Cart from "@/pages/Cart";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CharacterPage from "@/pages/CharacterPage";
import QuizResultPage from "@/pages/QuizResultPage";

const RequireAuth = ({ children, admin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-10 font-display text-3xl uppercase">Loading…</div>;
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function Shell() {
  return (
    <>
      <Navbar />
      <Toaster position="top-center" toastOptions={{ style: { border: "3px solid #1A1A1A", borderRadius: 0, boxShadow: "5px 5px 0 0 #1A1A1A", fontFamily: "Work Sans" } }} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/item/:id" element={<ItemDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/boggy" element={<CharacterPage />} />
        <Route path="/fox" element={<CharacterPage />} />
        <Route path="/quiz/:who" element={<QuizResultPage />} />
        <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
        <Route path="/admin" element={<RequireAuth admin><Admin /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <WishlistProvider>
            <CartProvider>
              <Shell />
            </CartProvider>
          </WishlistProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
